// extracted by mini-css-extract-plugin
export default {"dots":"_2f5874CayYQ0r6w3uv6YB6","dot-flashing":"UBgNKqW10aqE58dnu0K_o"};